import {forwardRef, useContext} from 'react';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import dateToString from '../../../../utilities/dateToString';
import {AppContext} from '../../../../context/AppContext';
import Icon from "../../../elements/Icon/Icon";
import styles from './DatePicker.module.scss';
import Button from "../../../elements/Button/Button";
import {useSelector} from "react-redux";
import dayjs from "dayjs";

const CustomInput = forwardRef(({isDisabled, value, onClick}, ref) => (
    <Button
        className={styles.customPicker}
        type="button"
        disabled={isDisabled}
        onClick={onClick}
        value={value}
    >
        {dateToString(value)}
        <Icon name={'calendar'} size={12} color="hsl(252, 94%, 67%)"/>
    </Button>
));

const DatePicker = ({handleInvoiceChange, value}) => {
    const {isInvoiceEdited} = useContext(AppContext);
    // const invoice = useSelector((state) => state.invoices.currentInvoice);

    return (
        <ReactDatePicker
            selected={new Date(value || new Date())}
            onChange={(date) =>
                handleInvoiceChange({ target: { name: "date", value: dayjs(date).format() } }, 'date', date)
            }
            minDate={new Date()}
            customInput={<CustomInput isDisabled={isInvoiceEdited}/>}
        />
    );
};

export default DatePicker;
